export default {
  methods: {
    async initwasm() {
      await DgovCryptoWasm.initWasm('@dgov/crypto-wasm/pkg/dgov_crypto_wasm_bg.wasm')
    }
  }
}
